// 判断一个商品是否含酒精。
// 逻辑与 cart/index.vue、venue-sub-group/cart/index.vue 现有 includeAlcohol 检测保持一致:
// 直接商品看 containsTags 是否含 'Alcohol';combo(type==='combo')看其子项 comboProducts[].itemList[].containsTags。
export function isAlcoholProduct(product) {
  if (!product) return false
  if ((product.containsTags ?? []).some((tag) => tag === 'Alcohol')) return true
  if (product.type === 'combo' && Array.isArray(product.comboProducts)) {
    return product.comboProducts.some((cp) =>
      (cp?.itemList ?? []).some((it) =>
        (it?.containsTags ?? []).some((tag) => tag === 'Alcohol')),
    )
  }
  return false
}
